//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../../keys_pb.js";
/**
 * Describes the file dxos/mesh/teleport/gossip.proto.
 */
export const file_dxos_mesh_teleport_gossip = /*@__PURE__*/ fileDesc("Ch9keG9zL21lc2gvdGVsZXBvcnQvZ29zc2lwLnByb3RvEhlkeG9zLm1lc2gudGVsZXBvcnQuZ29zc2lwIsoBCg1Hb3NzaXBNZXNzYWdlEiUKB3BlZXJfaWQYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EhIKCmNoYW5uZWxfaWQYAiABKAkSKAoKbWVzc2FnZV9pZBgDIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSLQoJdGltZXN0YW1wGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIlCgdwYXlsb2FkGAogASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueTJdCg1Hb3NzaXBTZXJ2aWNlEkwKCEFubm91bmNlEiguZHhvcy5tZXNoLnRlbGVwb3J0Lmdvc3NpcC5Hb3NzaXBNZXNzYWdlGhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5YgZwcm90bzM", [file_google_protobuf_empty, file_google_protobuf_any, file_google_protobuf_timestamp, file_dxos_keys]);
/**
 * Describes the message dxos.mesh.teleport.gossip.GossipMessage.
 * Use `create(GossipMessageSchema)` to create a new message.
 */
export const GossipMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_gossip, 0);
/**
 * @generated from service dxos.mesh.teleport.gossip.GossipService
 */
export const GossipService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_gossip, 0);
//# sourceMappingURL=gossip_pb.js.map